/* ============================================================
   NCS
   ============================================================ */

export const ncs = {
  id: "ncs",
  type: "playlist",
  featured: false,
  title: "NCS",
  link: "ncs",
  playlistBg: "rgb(163, 77, 255)",
  imgUrl: "/image/set/listas/1.jpg",
  hoverColor: "rgb(163, 77, 255)",
  artist: "ncs",
  artistImgUrl: "../image/djs/ncs/ncs.jpg", /* ../image/djs/ncs/ncs.jpg */
  artistBio: "Copyright free music for creators.",
  artistDownload: "",
  bannerUno: "",
  downloadData: [],
  playlistImages: [],
  playlistData: [
    {
      id: "1",
      songName: "IN MY HEAD",
      songimg: "../image/listas/ncs/in-my-head.jpg",
      songArtist: "SFRNG, SOVAGI & Aizu",
      artistLink: "sfrng",
      link: "https://dl.dropbox.com/scl/fi/m0ftl8917zhm2bn2jdztr/SFRNG-Aizu-SOVAGI-IN-MY-HEAD-NCS-Release.mp3?rlkey=kqugdjrmxr1y7zcuopgbhcc2a&st=h1u4ykir&dl=1",
      trackTime: "02:31",
      index: 0,
      genre: "house",
      genres: [
        "house"
      ]
    },
    {
      id: "2",
      songName: "off2 [NCS Release]",
      songimg: "../image/listas/ncs/off2.jpg",
      songArtist: "jonty",
      artistLink: "jonty",
      link: "https://dl.dropbox.com/scl/fi/g5zbq0ny6ag4koou8rfox/jonty-off2-NCS-Release.mp3?rlkey=8heup4fwjgzwvw9ftctqmot4y&st=cnqjlu4r&dl=1",
      trackTime: "03:39",
      index: 1,
      genre: "deep house",
      genres: [
        "deep house"
      ]
    },
    {
      id: "3",
      songName: "EYES ON US [NCS Release]",
      songimg: "../image/listas/ncs/eyes-on-us.jpg",
      songArtist: "2frers",
      artistLink: "2frers",
      link: "https://dl.dropbox.com/scl/fi/2lsqmbsfa7pgmp2arhtr3/2frers-EYES-ON-US-NCS-Release.mp3?rlkey=wcmwzz3aqqhyhwn0hhiwshb5y&st=8d9y86zf&dl=1",
      trackTime: "02:11",
      index: 2,
      genre: "house",
      genres: ["house"]
    },
    {
      id: "4",
      songName: "Groovy Chick [NCS Release]",
      songimg: "../image/listas/ncs/groovy-chick.jpg",
      songArtist: "BEANIE, Lauren Nicole, Gray Hoek",
      artistLink: "beanie",
      link: "https://dl.dropbox.com/scl/fi/hcetihz06j6jx4nbdxhda/BEANIE-Lauren-Nicole-Gray-Hoek-Groovy-Chick-NCS-Release.mp3?rlkey=cq3nvwiudswhtc4t4p8s015s7&st=pqzbkkz2&dl=1",
      trackTime: "02:27",
      index: 3,
      genre: "",
      genres: []
    },
    {
      id: "5",
      songName: "WOULD U [NCS Release]",
      songimg: "../image/listas/ncs/would-u.jpg",
      songArtist: "Conni, Lynxie",
      artistLink: "conni",
      link: "https://dl.dropbox.com/scl/fi/97l0rq4jep54maqkpw9ns/Conni-Lynxie-WOULD-U-NCS-Release.mp3?rlkey=k06bt3zsnxaqdp6n80gf1pgnp&st=p2h7id54&dl=1",
      trackTime: "02:37",
      index: 4,
      genre: "",
      genres: []
    },
    {
      id: "6",
      songName: "LOVESICK [NCS Release]",
      songimg: "../image/listas/ncs/lovesick.jpg",
      songArtist: "DJ PUMA",
      artistLink: "dj-puma",
      link: "https://dl.dropbox.com/scl/fi/oavbe0phcor3c3oeznisz/DJ-PUMA-LOVESICK-NCS-Release.mp3?rlkey=e3wsgks3mdsympjm3b9u6q4x9&st=pqne2f2z&dl=1",
      trackTime: "02:37",
      index: 5,
      genre: "",
      genres: []
    },
    {
      id: "7",
      songName: "whatdoyousee [NCS Release]",
      songimg: "../image/listas/ncs/whatdoyousee.jpg",
      songArtist: "GlitchCat, prodBigMike",
      artistLink: "glitchcat",
      link: "https://dl.dropbox.com/scl/fi/v7qb4ey1owba9xg4o3spu/GlitchCat-prodBigMike-whatdoyousee-NCS-Release.mp3?rlkey=25tepya3z0o6va7cwo77kiyva&st=wve2c2xk&dl=1",
      trackTime: "01:58",
      index: 6,
      genre: "",
      genres: []
    },
    {
      id: "8",
      songName: "KYOTO [NCS Release]",
      songimg: "../image/listas/ncs/kyoto.jpg",
      songArtist: "Hester",
      artistLink: "hester",
      link: "https://dl.dropbox.com/scl/fi/65c4rholxoyct0s5i7bng/Hester-KYOTO-NCS-Release.mp3?rlkey=8l6pltadasza09pem3sc7bj3p&st=3bxin1yl&dl=1",
      trackTime: "06:18",
      index: 7,
      genre: "",
      genres: []
    },
    {
      id: "9",
      songName: "I still hear your voice [NCE Release]",
      songimg: "../image/listas/ncs/i-still-hear-your-voice.jpg",
      songArtist: "Lynxie & johnny joined",
      artistLink: "lynxie",
      link: "https://dl.dropbox.com/scl/fi/ms9qeiyishrlknp2e5kqp/johnny-joined-Lynxie-i-still-hear-your-voice-NCS-Release.mp3?rlkey=0rx2rulw02f30nbi8st6q00ey&st=eoxg86v1&dl=1",
      trackTime: "02:18",
      index: 8,
      genre: "dance pop",
      genres: [
        "dance pop"
      ]
    },
    {
      id: "10",
      songName: "waiting for you  [NCS Release]",
      songimg: "../image/listas/ncs/waiting-for-you.jpg",
      songArtist: "Kkriegerz",
      artistLink: "kkriegerz",
      link: "https://dl.dropbox.com/scl/fi/1wn2nk6vjk0xowq474xsm/Kkriegerz-Waiting-For-You-NCS-Release.mp3?rlkey=tj26edl3ywv4rzb0581xcc4ym&st=ojnyo896&dl=1",
      trackTime: "02:16",
      index: 9,
      genre: "speed garage",
      genres: [
        "speed garage"
      ]
    },
    {
      id: "11",
      songName: "In Motion [NCS Release]",
      songimg: "../image/listas/ncs/in-motion.jpg",
      songArtist: "L3VI",
      artistLink: "l3vi",
      link: "https://dl.dropbox.com/scl/fi/h01txqmt0g83qk8gszer0/L3VI-in-motion-NCS-Release.mp3?rlkey=kho3um9098qk3952f074hkcg1&st=v2wfvx5v&dl=1",
      trackTime: "03:23",
      index: 10,
      genre: "",
      genres: []
    },
    {
      id: "12",
      songName: "LÖVI - virtual love 2001 [NCS Release]",
      songimg: "../image/listas/ncs/virtual-love.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/l9nnk37s0044lep8w89p4/L-VI-virtual-love-2001-NCS-Release.mp3?rlkey=91hfqynmwi71wcq5in4zewyzq&st=8d4y96fk&dl=1",
      trackTime: "03:24",
      index: 11,
      genre: "",
      genres: []
    },
    {
      id: "13",
      songName: "Reece Rosé, STREETSINEZ - This Feeling [NCS Release]",
      songimg: "../image/listas/ncs/this-feeling.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/tmn8iqlm7an455umwky33/Reece-Ros-STREETSINEZ-This-Feeling-NCS-Release.mp3?rlkey=wxm7drqqjfjz0ga27jaugdavc&st=6c3yw1li&dl=1",
      trackTime: "03:52",
      index: 12,
      genre: "",
      genres: []
    },
    {
      id: "14",
      songName: "ROY KNOX - Falling 4 U [NCS Release]",
      songimg: "../image/listas/ncs/falling-4.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/4dgxrhnisvhg4dlomqcz9/ROY-KNOX-Falling-4-U-NCS-Release.mp3?rlkey=hd0emhljn2hyyq7xcxw1tzux5&st=oba3j6g0&dl=1",
      trackTime: "03:45",
      index: 13,
      genre: "",
      genres: []
    },
    {
      id: "15",
      songName: "Bad Pitch For You [NCS Release]",
      songimg: "../image/listas/ncs/bad-pitch-for-you.jpg",
      songArtist: "ruindkid",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/e5z0nyenfygvxptiwh5qw/ruindkid-Bad-Pitch-For-You-NCS-Release.mp3?rlkey=muh5s8c0zv8btzs8h5tcbcxx2&st=omxskmos&dl=1",
      trackTime: "02:47",
      index: 14,
      genre: "dance pop",
      genres: [
        "dance pop"
      ]
    },
    {
      id: "16",
      songName: "Sace, defyer - jandro [NCS Release]",
      songimg: "../image/listas/ncs/jandro.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/hsnw8okleevh6ocqcfq7m/Sace-defyer-jandro-NCS-Release.mp3?rlkey=zdgxrpczjkxdiz5jy6e5ugus2&st=8nf5lh73&dl=1",
      trackTime: "02:22",
      index: 15,
      genre: "",
      genres: []
    },
    {
      id: "17",
      songName: "Set Me Free",
      songimg: "../image/listas/ncs/set-me-free.jpg",
      songArtist: "Sano",
      artistLink: "sano",
      link: "https://dl.dropbox.com/scl/fi/i91eejx8phixesg927mvl/Sano-SET-ME-FREE-NCS-Release.mp3?rlkey=v0rin2rqcltyv3xfgvrmxh4r7&st=venabe09&dl=1",
      trackTime: "03:25",
      index: 16,
      genre: "drum & bass",
      genres: [
        "drum & bass"
      ]
    },
    {
      id: "18",
      songName: "HIGHER [NCS Release]",
      songimg: "../image/listas/ncs/higher.jpg",
      songArtist: "Silver Bullet",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/5jgv896wyyva45ap6zfj5/Silver-Bullet-HIGHER-NCS-Release.mp3?rlkey=um6glddoz0ce1wdpebun20d6g&st=6ffo6j63&dl=1",
      trackTime: "03:53",
      index: 17,
      genre: "electro",
      genres: [
        "electro"
      ]
    },
    {
      id: "19",
      songName: "V. Christie - Atlas [NCS Release]",
      songimg: "../image/listas/ncs/atlas.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/gv7blk3k3x6ynxvt6rwf9/V.-Christie-Atlas-NCS-Release.mp3?rlkey=szlf48p47dik4ahlaww4yhfi1&st=x281pmun&dl=1",
      trackTime: "03:35",
      index: 18,
      genre: "",
      genres: []
    },
    {
      id: "20",
      songName: "V. Christie - Exoskeleton [NCS Release]",
      songimg: "../image/listas/ncs/exoskeleton.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/y1zj0cwcp191oyckoft57/V.-Christie-Exoskeleton-NCS-Release.mp3?rlkey=5kfasxz9ck7drz6na9sfxqgtx&st=x4htaiwi&dl=1",
      trackTime: "05:29",
      index: 19,
      genre: "",
      genres: []
    },
    {
      id: "21",
      songName: "V. Christie - Say You Love Me [NCS Release]",
      songimg: "../image/listas/ncs/say-you-love-me.jpg",
      songArtist: "",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/rxe5jgrmeycc5rdnf5zhv/V.-Christie-Say-You-Love-Me-NCS-Release.mp3?rlkey=rjtv3dyygy9jkw4ex78xb6ogm&st=fceh386l&dl=1",
      trackTime: "03:46",
      index: 20,
      genre: "",
      genres: []
    },
    {
      id: "22",
      songName: "Special [NCS Release]",
      songimg: "../image/listas/ncs/special.jpg",
      songArtist: "Yere",
      artistLink: "yere",
      link: "https://dl.dropbox.com/scl/fi/rk84bmzb54pmwom07d108/Yere-Special-NCS-Release.mp3?rlkey=z8b0f15f3292ljfj3lk2ystva&st=5pf4hz6n&dl=1",
      trackTime: "02:30",
      index: 21,
      genre: "house",
      genres: [
        "house"
      ]
    },
    {
      id: "23",
      songName: "Right Here [NCS Release]",
      songimg: "../image/listas/ncs/right-here.jpg",
      songArtist: "ZKG",
      artistLink: "zkg",
      link: "https://dl.dropbox.com/scl/fi/yiv0ijxj0n8mkk6kku3it/ZKG-RIGHT-HERE-NCS-Release.mp3?rlkey=t9mcn309cbwx7bpd7bvpcbqdv&st=m2jsy5lt&dl=1",
      trackTime: "02:15",
      index: 22,
      genre: "uk garage",
      genres: [
        "uk garage"
      ]
    },
    {
      id: "24",
      songName: "Amnesia",
      songimg: "../image/listas/ncs/amnesia.jpg",
      songArtist: "Pixel Terror",
      artistLink: "pixel-terror",
      link: "https://kzxhfwrnnuncrdmzaypg.supabase.co/storage/v1/object/sign/tracks/1753585984162_Pixel%20Terror%20-%20Amnesia.mp3?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82MmYwZmFhMi0wMTFlLTRlZTUtOGNhZC05YWNjMzUwMjU4ODYiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJ0cmFja3MvMTc1MzU4NTk4NDE2Ml9QaXhlbCBUZXJyb3IgLSBBbW5lc2lhLm1wMyIsInNjb3BlIjoiZG93bmxvYWQiLCJpYXQiOjE3ODc0MTUwOTMsImV4cCI6MTg1MDQ4NzA5M30.uUeEbfzV8FTgv4w6DoUL2_O4zINFq58LcFEUZvq-Png",
      trackTime: "03:45",
      index: 23,
      genre: "dubstep",
      genres: [
        "dubstep"
      ]
    }
  ]
}
